import React from 'react';
import { Link } from 'react-router-dom';
import img1 from '../img/carousel-img.png';

export default function Carousel() {
    return (
        <div>
            <div id="carouselExampleSlidesOnly" class="carousel slide" data-bs-ride="carousel">
                <div className='container-fluid'>
                    <div className='row'>
                        <div class="carousel-inner">
                            <div class=" col-12 col-lg-6 d-flex carousel-item active">
                                <img src={img1} class="image d-flex " alt="..." />
                                <div className='col-12 col-lg-6 content'>
                                    <span>fresh and organic</span>
                                    <h3>your daily need products</h3>
                                    <Link to="#" class="btn all-btn">Get started</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
